import { render } from "./Datainput.vue?vue&type=template&id=53765ea2&scoped=true"
import script from "./Datainput.vue?vue&type=script&lang=js"
export * from "./Datainput.vue?vue&type=script&lang=js"

import "./Datainput.vue?vue&type=style&index=0&id=53765ea2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53765ea2"

export default script